import { apiClient } from '@/infrastructure/api'
import {
  OpsApi,
  OpsApiRestockItemsRequest,
  OpsApiSubmitAuthorizationRequest,
  OpsApiCancelRequest,
  OpsApiMarkAsRefundedExternallyRequest
} from '@itsrever/rever-api'

const opsApi = new OpsApi(undefined, undefined, apiClient)

export async function createRestocks(args: OpsApiRestockItemsRequest) {
  const response = await opsApi.restockItems(args)
  return response.data
}

export async function submitAuthorization(
  args: OpsApiSubmitAuthorizationRequest
) {
  const response = await opsApi.submitAuthorization(args)
  return response.data
}

export async function cancelProcess(args: OpsApiCancelRequest) {
  const response = await opsApi.cancel(args)
  return response.data
}

export async function markAsRefundedExternally(
  args: OpsApiMarkAsRefundedExternallyRequest
) {
  const response = await opsApi.markAsRefundedExternally(args)
  return response.data
}
